/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { FC } from "react";
import Typography from "./Typography";
import { Props } from "dashboard-template/components/MDTypography";

/**
 * Base title component wrapper.
 * @param props - Typography props
 * @returns Typography component
 */
const Title: FC<Props> = (props) => {
  return <Typography {...props}>{props.children}</Typography>;
};

/**
 * H1 heading component (largest heading).
 * @param props - Typography props
 * @returns H1 typography with bottom margin
 */
export const H1: FC<Props> = (props) => {
  return (
    <Title sx={{ marginBottom: 3 }} variant="h1" component="h1" {...props}>
      {props.children}
    </Title>
  );
};

/**
 * H2 heading component (second level heading).
 * @param props - Typography props
 * @returns H2 typography with bottom margin
 */
export const H2: FC<Props> = (props) => {
  return (
    <Title sx={{ marginBottom: 2 }} variant="h2" component="h2" {...props}>
      {props.children}
    </Title>
  );
};

/**
 * H3 heading component (third level heading).
 * @param props - Typography props
 * @returns H3 typography
 */
export const H3: FC<Props> = (props) => {
  return (
    <Title variant="h3" component="h3" className="title-primary" {...props}>
      {props.children}
    </Title>
  );
};

/**
 * H4 heading component (fourth level heading).
 * @param props - Typography props
 * @returns H4 typography
 */
export const H4: FC<Props> = (props) => {
  return (
    <Title variant="h4" component="h4" className="title-secondary" {...props}>
      {props.children}
    </Title>
  );
};

/**
 * H5 heading component (fifth level heading).
 * @param props - Typography props
 * @returns H5 typography
 */
export const H5: FC<Props> = (props) => {
  return (
    <Title variant="h5" component="h5" className="subtitle" fontWeight="bold" {...props}>
      {props.children}
    </Title>
  );
};

/**
 * Caption text component (small descriptive text).
 * @param props - Typography props
 * @returns Caption typography
 */
export const Caption: FC<Props> = (props) => {
  return (
    <Title variant="body2" className="body-text" fontWeight="bold" sx={{ ...props.sx }} {...props}>
      {props.children}
    </Title>
  );
};
